module.exports = __webpack_public_path__ + "static/img/title.d06fa18d.png";